import { memo } from 'react';

import { ENCOUNTER_TYPES } from '@/types/encounter';
import { SeeAllLink, Typography } from '@/ui';

import type { Props } from './types';

const formatIcdCode = ({ code, description }: { code: string; description: string | null }) =>
  description ? `${code} ${description}` : code;

const PersonChartedDiagnoses = ({ chartedDiagnosis }: Props) => {
  const [leadDiagnosis, ...secondaryDiagnoses] = chartedDiagnosis.diagnoses;
  if (!leadDiagnosis) return null;

  const label =
    chartedDiagnosis.diagnoses.length > 1 ? 'Most Recent Diagnoses' : 'Most Recent Diagnosis';

  return (
    <div>
      <div className="flex items-center justify-between">
        <Typography muted>{label}</Typography>
        {chartedDiagnosis.appointment_attendance_id && (
          <SeeAllLink
            label="View encounter"
            to={`/encounters/${ENCOUNTER_TYPES.APPOINTMENT_ATTENDANCE}/by_id/${chartedDiagnosis.appointment_attendance_id}`}
          />
        )}
      </div>
      <Typography variant="subheading" className="mp-sensitive">
        {formatIcdCode(leadDiagnosis)}
      </Typography>
      {secondaryDiagnoses.map((diagnosis) => (
        <Typography key={diagnosis.code} muted className="mp-sensitive">
          {formatIcdCode(diagnosis)}
        </Typography>
      ))}
    </div>
  );
};

export default memo(PersonChartedDiagnoses);
